import { useContext } from "react";
import SlackIcon from "components/ui/icons/slack-icon.svg";
import { IconButton, Tooltip, Box } from "@mui/material";
import { ConstantContext } from "components/context/ConstantProvider";

const SlackLink = ({ slack_channel_id }) => {
  const disabled =
    !slack_channel_id || slack_channel_id === "SLACK_CHANNEL_NO_LINK";
  const { environmentVariables } = useContext(ConstantContext);

  return (
    <Tooltip title={`Slack - ${slack_channel_id}`}>
      <Box>
        <IconButton
          href={`slack://channel?team=${environmentVariables.SLACK_TEAMID}&id=${slack_channel_id}`}
          disabled={disabled}
        >
          <Box>
            <img
              src={SlackIcon}
              width="20px"
              height="20px"
              opacity={disabled ? "0.40" : 1}
            />
          </Box>
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default SlackLink;
